<template>
  <div class="sort-by-modal" @click="closeSortByModal()">
    <div class="sort-by-modal-content" data-analytics_available_call="0" @click.stop
      :style="{ top: `${position.top}px`, left: `${position.left}px` }">
      <div class="sort-by-element" @click="selectSortOption(lowToHighFilter)">Price: Low to High</div>
      <div class="sort-by-element" @click="selectSortOption(highToLowFilter)">Price: High to Low</div>
      <div class="sort-by-element" @click="selectSortOption('17')">Newest</div>
      <div class="sort-by-element" @click="selectSortOption('21')">Best sellers</div>
    </div>
  </div>
  <button id="sort-by-button-clone" data-element-id="Top_SortBy" @click="closeSortByModal()"
    :style="{ top: `${positionClone.top}px`, left: `${positionClone.left}px`, height: `${positionClone.height}px`, width: `${positionClone.width}px` }">
    SORT BY
    <div class="sort-by-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
          d="M7.99998 12.943L0.195312 5.13798L1.13798 4.19531L7.99998 11.057L14.862 4.19531L15.8046 5.13798L7.99998 12.943Z"
          fill="#222222" />
      </svg>
    </div>
  </button>
</template>

<script>
import SortByModal from "./SortByModal.ts";
export default {
  ...SortByModal,
};
</script>
<style lang="scss">
@import "./SortByModal.scss";
</style>